<div class="flex items-center" mat-dialog-title>
  <h2 class="headline m-0 flex-auto">
    {{ "Brand Edit" }}
  </h2>

  <button
    aria-label="close"
    class="text-secondary"
    mat-dialog-close
    mat-icon-button
    type="button">
    <mat-icon svgIcon="mat:close"></mat-icon>
  </button>
</div>

<mat-divider class="text-border"></mat-divider>

<mat-dialog-content>
  <!-- company brand request changes -->
  <form
    [formGroup]="form"
    class="grid grid-cols-1 md:grid-cols-2 gap-4"
    *ngIf="!isSubmitDisabled()">
    <mat-form-field>
      <mat-label>Brand Name</mat-label>
      <input
        formControlName="brandName"
        type="text"
        aria-label="Brand Name"
        matInput />
      <mat-error
        *ngIf="
          form.controls['brandName'].hasError('required') &&
          form.controls['brandName'].touched
        ">
        You must include a brand name
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Company Name</mat-label>
      <input
        formControlName="companyName"
        matInput
        type="text"
        aria-label="Company Name" />
      <mat-error
        *ngIf="
          form.controls['companyName'].hasError('required') &&
          form.controls['companyName'].touched
        ">
        You must include a company name
      </mat-error>
    </mat-form-field>

    <div class="flex flex-col gap-2 items-start">
      <!-- <mat-checkbox formControlName="isShowWebsite"
          >Show on Website</mat-checkbox
        > -->
      <label id="showonwebsite-radio-group-label" class="!ml-4 custom-label"
        >Show On Website</label
      >
      <mat-radio-group
        formControlName="isShowWebsite"
        aria-labelledby="showonwebsite-radio-group-label">
        <mat-radio-button value="Yes">Yes</mat-radio-button>
        <mat-radio-button value="No">No</mat-radio-button>
      </mat-radio-group>
    </div>
    <div>
      <mat-radio-group
        formControlName="status"
        aria-labelledby="status-radio-group-label">
        <mat-radio-button value="none">No change</mat-radio-button>
        <mat-radio-button
          *ngIf="showRadioButtonValues(['Active', 'Pending'])"
          value="isTerminate"
          >Terminate</mat-radio-button
        >
        <mat-radio-button
          *ngIf="showRadioButtonValues(['Terminated'])"
          value="isReactivate"
          >Reactivate</mat-radio-button
        >
      </mat-radio-group>
    </div>
  </form>

  <div *ngIf="isSubmitDisabled()" class="flex flex-row justify-center my-6">
    <vex-page-loader></vex-page-loader>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="flex flex-row justify-end">
  <button
    color="primary"
    mat-flat-button
    type="submit"
    (click)="onSubmit()"
    [disabled]="isSubmitDisabled()">
    Submit
  </button>
</mat-dialog-actions>
